import { GetProjectMembers, GetProjectMembersResponse } from '../types'

function mapProjectMembers(response: Partial<GetProjectMembersResponse> = []): GetProjectMembers {
  return response?.map((item) => mapProjectMember(item)) || []
}

function mapProjectMember(response: Partial<GetProjectMembersResponse[0]> = {}): GetProjectMembers[0] {
  return {
    id: response?.id || 0,
    firstname: response?.firstname || '',
    lastname: response?.lastname || '',
    email: response?.email || '',
    image: response?.image || '',
  }
}

const mappers = { mapProjectMembers, mapProjectMember }

export default mappers
